<div class="avatar-container" [ngClass]="getSizeClass()">
  <!-- Imagem do usuário -->
  <img 
    *ngIf="!showDefaultIcon"
    [src]="src" 
    [alt]="alt" 
    class="avatar-image"
    (error)="onImageError()"
    loading="lazy"
  />
  
  <!-- Ícone padrão quando não há foto -->
  <div 
    *ngIf="showDefaultIcon"
    class="avatar-default-icon"
  >
    <i class="fas fa-user"></i>
  </div>
  
  <!-- Indicador de status (opcional) -->
  <div 
    *ngIf="showStatus"
    class="status-indicator"
    [ngClass]="getStatusClass()"
  ></div>
</div>
